import React from 'react';
import {
	Typography,
	Box,
	Container,
	Grid,
	ListItem,
	List,
	ListItemButton,
	ListItemText,
} from '@mui/material';
import { ContentContainer } from './ContentContainer';
import { Link } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';

const menuItems = [
	{ label: 'Home', link: '/' },
	{ label: 'About', link: '/about' },
	{ label: 'Contact', link: '/contact' },
];

const Foot = ({sx={}}) => {
	const handleIgIconCliked = () => {
		const url = `https://www.instagram.com/yecocanada/`;
		window.open(url, '_blank');
	};

	const handleFbIconCliked = () => {
		const url = `https://www.facebook.com/yecocanada`;
		window.open(url, '_blank');
	};

	return (
		<Container sx={{background:"#C6C6C6", ...sx}}>
			<Grid
				container
				justifyContent="center"
				gap="12px"
			>
				<ContentContainer title={'Socials'} sx={sx}>
					<Container
						sx={{
							background: '',
							display: 'flex',
							justifyContent: 'center',
							width: 'fit-content',
							marginTop: '.5em',
							gap: '12px',

							
						}}
					>
						<Box sx={{ background: '' }}>
							<IconButton
								size="small"
								color="primary"
								onClick={handleIgIconCliked}
								sx={{ background: '#2C73D2', color: 'white',}}
							>
								<InstagramIcon />
							</IconButton>
						</Box>

						<Box sx={{ background: '' }}>
							<IconButton
								size="small"
								color="primary"
								onClick={handleFbIconCliked}
								sx={{ background: '#2C73D2', color: 'white'}}
							>
								<FacebookRoundedIcon />
							</IconButton>
						</Box>
					</Container>
				</ContentContainer>

				<ContentContainer title="Contact" sx={sx}>
					<Box
						variant="p"
						component="p"
						sx={{
							background: '',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'flex-start',
							color: 'gray',
							flexDirection: 'column',
							lineHeight: '1.4',
						}}
					>
						<Typography variant="p">
							Address:&nbsp; 815 St Laurent Blvd, Suite 235
						</Typography>
						<Typography variant="p">Ottawa, &nbsp;ON K1K 3A7</Typography>
						<Typography variant="p">
							Ph: &nbsp;613-236-9300/Fax:&nbsp;613-236-7060
						</Typography>
						<Typography variant="p">
							Email: &nbsp;yecocanada@gmail.com
						</Typography>
					</Box>
				</ContentContainer>

				<ContentContainer title="Menu" sx={sx}>
					<List>
						{menuItems.map((item) => (
							<ListItem key={item.label} disablePadding>
								<ListItemButton
									sx={{ textAlign: 'center', background: '', padding: '0' }}
								>
									<Link
										to={item.link}
										style={{ textDecoration: 'none', color: '#2C73D2' }}
									>
										{' '}
										<ListItemText primary={item.label} />
									</Link>
								</ListItemButton>
							</ListItem>
						))}
					</List>
				</ContentContainer>
			</Grid>
      <Box sx={{display:"flex", justifyContent:"center", alignItems:"center", background: 'hsl(0, 0%, 41%)', height: 'fit-content', color: 'white', gap:"1em", padding:"1em",}}>
				<span>&copy;2022</span> YECO-Canada
			</Box>
		</Container>
	);
};

export default Foot;
